query GetFleetUsage {
  months: StreamToolsGetFleetUsage {
    month
    counters {
      votesIngested
      uploads
      uploadBytes
      republishes
      overlayTokenMints
      ticketExchanges
      ytUnits
      ytSessionsStarted
      ytSessionSeconds
      eventsCreated
      chatOverlaysCreated
      emoteWallsCreated
      merchOverlaysCreated
      pollsCreated
      tugsCreated
      boardsCreated
    }
    estimatedCents
    accountCount
    accountsWithUsage
    rolledUpAt
  }
}
